export const formatMileage = (miles: number): string => {
  if (isNaN(miles)) {
    return null;
  }
  return new Intl.NumberFormat("en-GB", {
    style: "unit",
    unit: "mile",
    minimumFractionDigits: 0,
  }).format(Number(miles)); // 7,574 mi
};
